const timeAxis = () => import("@/components/common/timeAxis/Index.vue");
import * as clipWork from "./map1.js";
// import { roadModelData } from "./Shinbashi";
import { roadModelData } from "./Shinbashi2";
import * as photoGraphic from "@/components/common/photoGraphic/map.js";
export default {
  components: {
    timeAxis,
  },
  data() {
    return {
      showTimeAxis: false,
      marks: {
        0: "开始",
        5: "关键帧",
        10: "",
        15: "关键帧",
        20: "",
        25: "关键帧",
        30: "",
        35: "关键帧",
        40: "",
        45: "关键帧",
        50: "",
        55: "关键帧",
        60: "",
        65: "关键帧",
        70: "",
        75: "关键帧",
        80: "",
        85: "关键帧",
        90: "",
        95: "关键帧",
        100: "",
        105: "关键帧",
        110: "",
        115: "关键帧",
        120: "",
        125: "关键帧",
        130: "",
        135: "关键帧",
        140: "",
        145: "关键帧",
        150: "",
        155: "关键帧",
        160: "",
        165: "关键帧",
        170: "",
        175: "关键帧",
        180: "",
        185: "关键帧",
        190: "结束",
      },
      addArr: [],
      flightData: {
        lat: 24.82208442,
        lng: 118.52054948,
        alt: 372.1,
        heading: 49.9,
        pitch: -40.6,
      },
      // childId: window.sessionStorage.getItem("childId"),
      childId: "NewNode-37a36db7-a445-4e72-95b1-dfa572ee4aa7",
    };
  },
  methods: {
    keyFrameFn(e) {
      let tilesetLayer = this.$GLOBAL.map.getLayer(this.childId, "modelId");
      if (tilesetLayer) {
        this.addArr = [];
        roadModelData.forEach((item) => {
          if (e >= item.time) {
            this.addArr.push(item.id);
          }
        });

        clipWork.dateNumFun(this.childId, this.addArr);
      }
    },
    playpause(type) {},
    redo() {
      this.addArr = [];
      clipWork.dateNumFun(this.childId, this.addArr);
    },
    watchValue(v) {
      // clipWork.dateNumFun(this.childId, v);
    },
  },
  mounted() {
    this.addArr = [];

    photoGraphic.flight(this.flightData, null, (e) => {
      this.showTimeAxis = true;
    });
  },
  destroyed() {},
  watch: {},
};
